import IconButton from "@material-ui/core/IconButton"
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined"
import React, { forwardRef } from "react"
import styled from "styled-components"

interface IProps {
  className?: string | undefined
}

const Icon = styled(IconButton)`
  z-index: 10;
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};

  transition: all ${({ theme }) => theme.transitions.duration.standard}ms
    ease-in-out;

  :hover {
    background-color: ${({ theme }) => theme.palette.primary.dark};
  }
`

const GoToBtn = forwardRef<HTMLElement, IProps>(({ className }, ref) => {
  if (typeof ref !== "object") return null

  const handleClick = () =>
    ref?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    })

  return (
    <Icon onClick={handleClick} className={className}>
      <InfoOutlinedIcon />
    </Icon>
  )
})

export default GoToBtn
